import axios from "axios";
import { BASE_URL } from "./api";


export async function convertCurrencyToUSD(token, { amount, currency, date }) {
    const params = new URLSearchParams({ amount: String(amount), currency, date });
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/convert-currency/?${params.toString()}`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response.data)
}


export async function getExpenses(token, queryParams = "") {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function getExpense(token, id) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/${id}/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function createExpense(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: payload,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function updateExpense(token, id, payload) {
    return axios({
        method: 'patch',
        url: `${BASE_URL}/expense-records/${id}/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: payload,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function deleteExpense(token, id) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/expense-records/${id}/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function submitExpense(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/submit/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function getExpenseGroupLabels(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/group-labels/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function bulkSetExpenseGroupLabel(token, recordIds, label) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-set-group-label/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: { record_ids: recordIds, label: label || '' },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function bulkSubmitExpenses(token, recordIds) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-submit/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: { record_ids: recordIds },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function recallExpense(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/recall/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function bulkRecallExpenses(token, recordIds) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-recall/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: { record_ids: recordIds },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function managerApproveExpense(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/manager-approve/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function managerRejectExpense(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/manager-reject/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: { reason },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function getMyTeam(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/my-team/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function accountingApproveExpense(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/accounting-approve/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function accountingRejectExpense(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/accounting-reject/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function bulkMarkReimbursed(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-mark-reimbursed/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function downloadInvoicingPackage(token, recordIds) {
    const response = await axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/export-invoicing-package/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds },
        responseType: 'blob',
    });
    let filename = 'invoicing-package.zip';
    const disposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
    if (disposition) {
        const match = /filename="?([^";]+)"?/.exec(disposition);
        if (match) filename = match[1];
    }
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return filename;
}


export async function bulkMarkClientInvoiced(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-mark-client-invoiced/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function bulkMarkClientPaid(token, recordIds, paidOn) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-mark-client-paid/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds, paid_on: paidOn },
    }).then((r) => r.data);
}


export async function bulkMarkBankReconciled(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-mark-bank-reconciled/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function bulkManagerApprove(token, recordIds) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-manager-approve/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds },
    }).then((r) => r.data);
}


export async function bulkManagerReject(token, recordIds, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-manager-reject/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds, reason },
    }).then((r) => r.data);
}


export async function bulkAccountingApprove(token, recordIds) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-accounting-approve/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds },
    }).then((r) => r.data);
}


export async function bulkAccountingReject(token, recordIds, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-accounting-reject/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { record_ids: recordIds, reason },
    }).then((r) => r.data);
}


export async function adminOverrideStatus(token, id, newStatus, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-override-status/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { new_status: newStatus, reason },
    }).then((r) => r.data);
}


export async function adminReassignManager(token, id, newManagerId, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-reassign-manager/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { new_manager_id: newManagerId, reason },
    }).then((r) => r.data);
}


export async function adminSoftDelete(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-soft-delete/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function adminRestore(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-restore/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function notifyManagers(token, expenseIds) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/notify-managers/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { expense_ids: expenseIds },
    }).then((r) => r.data);
}


export async function adminUnmarkReimbursed(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-unmark-reimbursed/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function adminUnmarkClientPaid(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-unmark-client-paid/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function adminUnmarkBankReconciled(token, id, reason) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${id}/admin-unmark-bank-reconciled/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { reason },
    }).then((r) => r.data);
}


export async function getExpenseReportBatches(token, queryParams = '') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-report-batches/${queryParams}`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getExpenseReport(token, reportName, queryParams = '') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-reports/${reportName}/${queryParams}`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getExpenseHistory(token, id) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-records/${id}/history/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export function expenseReportCsvUrl(reportName, queryParams = '') {
    const qp = queryParams ? (queryParams + '&format=csv') : '?format=csv';
    return `${BASE_URL}/expense-reports/${reportName}/${qp}`;
}


export async function getExpensePickerClients(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-picker-clients/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getExpensePickerEngagements(token, queryParams = '') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-picker-engagements/${queryParams}`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}
